var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudited(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 141,
    viewBox: "0 0 113 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_i_597_13410)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7895 0.00366482C55.6699 0.0154031 55.5514 0.0330112 55.433 0.0564878C54.7587 0.159786 54.129 0.456759 53.6201 0.913405C53.6025 0.929839 53.5849 0.948622 53.5673 0.966228C53.2354 1.20452 46.9488 5.71329 37.3823 10.5177C27.5673 15.4445 14.7899 20.2712 3.49582 20.2712H0V70.4764C0 96.1142 13.9359 113.758 27.5877 124.645C41.2399 135.535 54.9422 140.093 54.9422 140.093L56.0304 140.456L57.1386 140.093C57.1386 140.093 70.8421 135.535 84.4931 124.645C98.1452 113.756 112.081 96.1127 112.081 70.4764V20.2712H108.558C97.2621 20.2712 84.506 15.4445 74.6898 10.5129C65.0576 5.67422 58.6489 1.06239 58.4027 0.885092L58.4039 0.886266C57.8821 0.421416 57.2348 0.123255 56.5429 0.0305199H56.4901C56.3858 0.0164335 56.2802 0.00821691 56.1747 0.00352153H56.1219C56.0105 -0.00117384 55.8979 -0.00117384 55.7865 0.00352153L55.7895 0.00366482ZM56.0357 35.0905C65.3242 35.0905 74.2329 38.7846 80.801 45.3593C87.3691 51.9341 91.0582 60.8518 91.0582 70.1497C91.0582 79.4476 87.3691 88.3654 80.801 94.9401C74.2329 101.515 65.3242 105.208 56.0357 105.208C46.7473 105.208 37.8386 101.515 31.2705 94.9401C24.7024 88.3654 21.0121 79.4476 21.0121 70.1497C21.0121 60.8518 24.7024 51.9341 31.2705 45.3593C37.8386 38.7846 46.7473 35.0905 56.0357 35.0905ZM75.2098 52.5925C73.8436 52.6289 72.5455 53.1958 71.5909 54.1748L50.8021 75.0118L40.4863 64.6855H40.4875C39.5048 63.676 38.1598 63.1032 36.7527 63.095C35.3455 63.0868 33.9946 63.6443 33.0002 64.6409C32.007 65.6387 31.4547 66.9933 31.4664 68.402C31.4793 69.8106 32.055 71.1559 33.0647 72.1349L47.0813 86.1648V86.166C48.0663 87.1473 49.3997 87.699 50.7894 87.699C52.179 87.699 53.5123 87.1473 54.4962 86.166L79.006 61.6046C80.0145 60.6139 80.5809 59.2593 80.5797 57.8447C80.5774 56.4314 80.0075 55.0779 78.9978 54.0896C77.987 53.1012 76.622 52.5624 75.2102 52.5929L75.2098 52.5925Z",
    fill: "#D3FFF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_597_13410",
    x: 0,
    y: 0,
    width: 112.081,
    height: 142.347,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.89166
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.36457
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_597_13410"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudited);
export default __webpack_public_path__ + "static/media/audited.1e8a90f9bf677a61d7b43d63fe39332e.svg";
export { ForwardRef as ReactComponent };